import { render, staticRenderFns } from "./rebind.vue?vue&type=template&id=00dfa9d2&scoped=true&"
import script from "./rebind.vue?vue&type=script&lang=js&"
export * from "./rebind.vue?vue&type=script&lang=js&"
import style0 from "./rebind.vue?vue&type=style&index=0&id=00dfa9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dfa9d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00dfa9d2')) {
      api.createRecord('00dfa9d2', component.options)
    } else {
      api.reload('00dfa9d2', component.options)
    }
    module.hot.accept("./rebind.vue?vue&type=template&id=00dfa9d2&scoped=true&", function () {
      api.rerender('00dfa9d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/rebind.vue"
export default component.exports